const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1'

interface EventProps {
  [key: string]: string | number | boolean | null | undefined
}

const queue: { name: string; props: EventProps }[] = []
let flushTimer: ReturnType<typeof setTimeout> | null = null

function flush() {
  if (!queue.length) return
  const events = queue.splice(0, queue.length)
  const token  = (() => {
    try {
      const raw = localStorage.getItem('pq_auth') ?? localStorage.getItem('pq_student_auth')
      return raw ? (JSON.parse(raw) as { state?: { token?: string } })?.state?.token : undefined
    } catch { return undefined }
  })()

  fetch(`${API_BASE}/analytics/events`, {
    method:  'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ events }),
    keepalive: true,
  }).catch(() => {/* non-fatal */})
}

// Children's screens never send analytics, whatever an adult on the same
// device agreed to (ICO Children's Code: off by default for children).
export function isChildRoute(path = window.location.pathname): boolean {
  return path.startsWith('/student') || path.startsWith('/join')
}

function analyticsAllowed(): boolean {
  if (isChildRoute()) return false
  try {
    return localStorage.getItem('pq_cookie_consent') === 'accepted'
  } catch {
    return false
  }
}

export function trackEvent(name: string, props: EventProps = {}) {
  if (!analyticsAllowed()) return   // respect cookie consent (GDPR/ePrivacy)
  queue.push({ name, props: { ...props, ts: Date.now() } })
  if (flushTimer) clearTimeout(flushTimer)
  flushTimer = setTimeout(flush, 3000)
}

// Flush before page unload
if (typeof window !== 'undefined') {
  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush()
  })
}
